import {
  FETCHING_DATASET_FAILED,
  FETCHING_DATASET_REQUEST,
  FETCHING_DATASET_SUCCEDDED,
} from './actionTypes.js';

import axios from 'axios';
import buildUrl from 'build-url-ts';
import { createAction } from '@reduxjs/toolkit';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  FetchDatasetErrorResponse,
  FetchDatasetRequest,
  FetchDatasetResponse,
} from '../../types/dataseek.js';

export const fetchDataset = createAction<FetchDatasetRequest>(FETCHING_DATASET_REQUEST);
const fetchingDatasetSucceeded = createAction<FetchDatasetResponse>(FETCHING_DATASET_SUCCEDDED);
const fetchingDatasetFailed = createAction<FetchDatasetErrorResponse>(FETCHING_DATASET_FAILED);

const fetchDatasetSaga = function* (action: ReturnType<typeof fetchDataset>): any {

  const { appId, datasetId, language } = action.payload;

  const apiEndpoint = buildUrl(process.env.API_URL, {
    path: '/dataset-resource',
    queryParams: {
      idb_id: datasetId,
    }
  });

  const data = {
    datasetId: datasetId,
  }

  const fetchDatasetApi = () => {
    return axios({
      method: 'GET',
      url: apiEndpoint,
      data: data
    }).then((response: { data: any; }) => response.data);
  };

  try {
    const response: FetchDatasetResponse = yield call(fetchDatasetApi);
    yield put(fetchingDatasetSucceeded(response));
  } catch (error) {
    yield put(fetchingDatasetFailed({
      error: error
    }));
  }
}

export default function* datasetSaga() {
  yield takeEvery(FETCHING_DATASET_REQUEST, fetchDatasetSaga);
}